import { Injectable, EventEmitter, Output } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

import { SegmentValidationService } from 'shared/validation/segment-validation/segment-validation.service';
import { rightPanelNavs } from './right-panel-navs';
import { segmentsData } from './segments-data-stub';
import { pageOptions } from './product-details-options';


@Injectable()
export class ProductDetailsService {

  uiModel: any = {
    isHeaderMinSubject: new BehaviorSubject<boolean>(false),
    isHeaderMinimized: false,
    headerMinHeight: pageOptions.headerMinHeight,
    segmentItemOffsets: pageOptions.segmentItemOffsets,
  };

  model: any = {
    productId: null,
    segment: '',
    isPanelOpened: false,
    items_details: segmentsData.items_details,
    descriptions: segmentsData.descriptions,
    attributes: segmentsData.attributes,
    packages: segmentsData.packages,
    extendedInformation: segmentsData.extendedInformation,
    prices: segmentsData.prices,
    fitments: segmentsData.fitments,
    kits: segmentsData.kits,
    digitalAssets: segmentsData.digitalAssets,
    interchanges: segmentsData.interchanges,
    marketing: segmentsData.marketing
  };
}
